import { createContext, useContext, createElement } from "react";
import type { ReactNode } from "react";
import type { ApiClient } from "./client";
import { createHealthService, type HealthService } from "./health";
import { createReportingService, type ReportingService } from "./reporting";
import { createSystemService, type SystemService } from "./system";
import { createObligorService, type ObligorService } from "./obligor";

interface ApiServices {
  health: HealthService;
  reporting: ReportingService;
  system: SystemService;
  obligor: ObligorService;
}

const ApiClientContext = createContext<ApiServices | null>(null);

export function ApiClientProvider({
  client,
  children,
}: {
  client: ApiClient;
  children: ReactNode;
}) {
  const services: ApiServices = {
    health: createHealthService(client),
    reporting: createReportingService(client),
    system: createSystemService(client),
    obligor: createObligorService(client),
  };

  return createElement(
    ApiClientContext.Provider,
    { value: services },
    children,
  );
}

export function useApi(): ApiServices {
  const ctx = useContext(ApiClientContext);
  if (!ctx) {
    throw new Error("useApi must be used within ApiClientProvider");
  }
  return ctx;
}
